"use client"; // This is a client-side component

import React from 'react';

import { usePathname } from 'next/navigation';
import { track } from '@vercel/analytics';
import Link from 'next/link';
import { LocaleCode, localeStrings } from '@/translations/config';

const englishStrings = { heading: 'Choose Your Ending', slowdown: 'Slowdown', race: 'Race' };

const ChooseEnding = ({ locale }: { locale?: LocaleCode }) => {
  const pathname = usePathname();
  const strings = locale ? localeStrings[locale].chooseEnding : englishStrings;
  const prefix = locale ? `/${locale}` : '';
  const selectedEnding = pathname.includes('slowdown') ? 'slowdown' : pathname.includes('race') ? 'race' : '';
  const handleEndingSelection = (ending: 'race' | 'slowdown') => {
    track('ending_selected', { ending });
  };

  return (
    <>
      <div className="ending-options text-center [grid-area:choice] mt-[00px] mb-[50px]">
        <h2 className="text-4xl font-bold mb-4">{strings.heading}</h2>
        <div className="flex flex-row justify-center gap-4">
          <Link href={`${prefix}/slowdown`} className="w-1/2">
            <button
              className={`px-4 py-4 rounded bg-[var(--slowdown-background)] text-white w-full text-2xl ${selectedEnding === 'race' ? 'saturate-50 opacity-50' : ''}`}
              onClick={() => handleEndingSelection('slowdown')}
            >
              {strings.slowdown}
            </button>
          </Link>
          <Link href={`${prefix}/race`} className="w-1/2">
            <button
              className={`px-4 py-4 rounded bg-[var(--race-background)] text-white w-full text-2xl ${selectedEnding === 'slowdown' ? 'saturate-50 opacity-50' : ''}`}
              onClick={() => handleEndingSelection('race')}
            >
              {strings.race}
            </button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ChooseEnding; 